<template>
  <v-app dark>
    <!-- Legal/About dialog -->
    <dialog-legal/>

    <!-- Help dialog -->
    <dialog-help/>

    <!-- Login dialog -->
    <dialog-login/>

    <!-- Add point dialog -->
    <dialog-add-point/>

    <!-- Data view snowmaking hydrants -->
    <data-snowmaking-hydrants/>
    <data-liftmaintenance-cables/>

    <!-- Side bar -->
    <v-navigation-drawer temporary v-model="drawer" enable-resize-watcher fixed app>
      <v-list>
        <!-- Satellite Imagry -->
        <v-list-group>
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>Satellite Imagry</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="toggle_imagry_summer2014">
            <v-list-tile-content>
              <v-list-tile-title>Summer 2014 (40cm resolution)</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-switch v-model="toggle_imagry_summer2014_state"></v-switch>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <!-- Auto generated -->
        <v-list-group v-for="
          dept in computedDeptData"
          :key="dept.id"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ dept.deptTitle }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-for="
            layer in dept.mapLayers"
            :key="layer.id"
            v-model="layer.visibility.mapView"
            @click="toggleMapLayer(dept.name, layer.name)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ layer.layerTitle }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn
                icon
                @click="toggleListLayer(dept.name, layer.name)"
                @click.stop
              >
                <v-icon>list</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action>
              <v-switch
                v-model="layer.visibility.mapView"            
                @click="toggleMapLayer(dept.name, layer.name)"
                @click.stop
              >
              </v-switch>
            </v-list-tile-action>

          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{ general_title_state }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Three dots menu -->
      <v-menu offset-y>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="methodDialogUi('dialogLogin')">
            <v-list-tile-title>Log In</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="toggle_data_snowmaking_hydrants">
            <v-list-tile-title>Change Password</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="methodDialogUi('dialogHelp')">
            <v-list-tile-title>Help</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="methodDialogUi('dialogLegal')">
            <v-list-tile-title>About/Legal</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <router-view/>
  </v-app>
</template>

<script>
  import dialogLogin from './components/dialogLogin.vue'
  import dialogHelp from './components/dialogHelp.vue'
  import dialogLegal from './components/dialogLegal.vue'
  import dialogAddPoint from './components/dialogAddPoint.vue'
  import dataSnowmakingHydrants from './components/dataSnowmakingHydrants.vue'
  import dataLiftmaintenanceCables from './components/dataLiftmaintenanceCables.vue'

  export default {
    data () {
      return {
        drawer: false
      }
    },
    computed: {
      toggle_imagry_summer2014_state: {
        get: function () {
          return this.$store.state.toggle.imagry.summer_2014_40cm
        },
        set: function () {
          this.toggle_imagry_summer2014()
        }
      },
      general_title_state: {
        get: function () {
          return this.$store.state.general.title
        }
      },
      toggle_add_point_state: {
        get: function () {
          return this.$store.state.toggle.add.point
        },
        set: function () {
          this.toggle_add_point()
        }
      },
      toggle_data_snowmaking_hydrants_state: {
        get: function () {
          return this.$store.state.toggle.data.snowmaking.hydrants
        },
        set: function () {
          this.toggle_data_snowmaking_hydrants()
        }
      },
      toggle_data_liftmaintenance_cables_state: {
        get: function () {
          return this.$store.state.toggle.data.liftmaintenance.cables
        },
        set: function () {
          this.toggle_data_liftmaintenance_cables()
        }
      },
      computedDeptData: {
        get: function () {
          return this.$store.state.layers
        }
      }
    },
    methods: {
      methodDialogUi (dialog) {
        this.$store.commit('mutationDialogUi', {
          dialog
        })
      },
      toggle_imagry_summer2014 () {
        this.$store.commit('toggleSummer2014')
      },
      toggle_dialog_help () {
        this.$store.commit('toggleDialogHelp')
      },
      toggle_dialog_legal () {
        this.$store.commit('toggleDialogLegal')
      },
      toggle_dialog_login () {
        this.$store.commit('toggleDialogLogin')
      },
      toggle_dialog_add_point () {
        this.$store.commit('toggleDialogAddPoint')
      },
      toggle_data_snowmaking_hydrants () {
        this.$store.commit('toggleDataSnowmakingHydrants')
      },
      toggle_data_liftmaintenance_cables () {
        this.$store.commit('toggleDataLiftmaintenanceCables')
      },
      toggleMapLayer (dept, layer) {
        this.$store.commit('mutationMapLayer', {
          dept,
          layer
        })
      },
      toggleListLayer (dept, layer) {
        this.$store.commit('mutationListLayer', {
          dept,
          layer
        })
      }
    },
    components: {
      'dialog-login': dialogLogin,
      'dialog-help': dialogHelp,
      'dialog-legal': dialogLegal,
      'dialog-add-point': dialogAddPoint,
      'data-snowmaking-hydrants': dataSnowmakingHydrants,
      'data-liftmaintenance-cables': dataLiftmaintenanceCables
    },
    name: 'App'
  }
</script>


// WEBPACK FOOTER //
// src/App.vue